import * as qs from '@/ui/queryState';
import { endsToday, startsLast30Days } from '@/ui/helpers/dateHelper';

export const useQueryFiltering = () => ({
  start: qs.date('start', startsLast30Days()),
  end: qs.date('end', endsToday()),
  group: qs.numbers('group', []),
  entityItem: qs.numbers('entityItem', []),
  entityFolder: qs.strings('entityFolder', []),
  assignee: qs.numbers('assignee', []),
  category: qs.numbers('category', []),
  checklist: qs.numbers('checklist', []),
  response: qs.strings('response', []),
  section: qs.strings('section', []),
  questionTitle: qs.strings('questionTitle', []),
});
